'use strict';

var $ = require('jquery');

function checkZgloszenie(){
  var E = $("#email2").val();
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if(!E || !re.test(E)) { alert("Prosimy wpisać prawidłowy adres email"); return false;}
  var P = $("#powod").val();
  if(!P) { alert("Prosimy wpisać powód zgłoszenia"); return false;}
  return true;
}

var konkursMM = function () {

  // take over the scroll in Internet Explorer so there is no fixed background flickering
  if( navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.indexOf("MSIE") > 0 ) { // if IE
    $('body').on("mousewheel", function () {
      // remove default behavior
      event.preventDefault();

      //scroll without smoothing
      var wheelDelta = event.wheelDelta;
      var currentScrollPosition = window.pageYOffset;
      window.scrollTo(0, currentScrollPosition - wheelDelta);
    });
  }

  var body = $('body');
  body.on('click', '.zglosClose', function(e){
    $(".zglosPanel").removeClass('zglosPanel--open');
    //$(".zglos").fadeIn();
    e.preventDefault();
  })

  $(".zglos").click(function(){
    $(".zglosPanel").toggleClass('zglosPanel--open');
    return false;
  });

  $(".search-submit").click(function(e){
    e.preventDefault();
    $(".form-szukaj").submit();
  });

  $(".form-szukaj").on("submit",function(e){
    e.preventDefault();
    var i = $("#imie").val();
    var w = $("#wiek").val();
    document.location.href = "galeria"+(i?"/imie:"+i:"")+(w && parseInt(w)>0?"/wiek:"+w:"");
    return false;
  });

};

module.exports = konkursMM;
